import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";
import { Building2 } from "lucide-react";

export default function Login() {
  const { user, checked, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (checked && user) navigate("/", { replace: true });
  }, [checked, user, navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const r = await login(email, password);
    setLoading(false);
    if (r.ok) {
      toast.success("Hoş geldiniz!");
      navigate("/", { replace: true });
    } else {
      toast.error(r.error);
    }
  };

  return (
    <div className="min-h-screen bg-background grid md:grid-cols-2">
      {/* Left: brand side */}
      <div className="hidden md:flex flex-col justify-between p-12 bg-slate-900 text-white relative overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_rgba(59,130,246,0.25),_transparent_60%)]" />
        <div />
        <div className="relative z-10 space-y-6">
          <h1 className="font-display font-extrabold text-4xl lg:text-5xl leading-tight tracking-tight" data-testid="login-brand-text">
            Türkanlar Yönetim Paneli - Özel Kullanıma mahsustur.
          </h1>
          <div className="grid grid-cols-3 gap-4 pt-6 border-t border-white/10">
            <Stat k="Modül" v="6" />
            <Stat k="Dil" v="TR" />
            <Stat k="Rapor" v="Canlı" />
          </div>
        </div>
        <div className="relative z-10 text-xs text-slate-400">© 2026 · Tüm hakları saklıdır.</div>
      </div>

      {/* Right: form */}
      <div className="flex items-center justify-center p-6 md:p-12">
        <Card className="w-full max-w-md p-8 shadow-xl">
          <div className="md:hidden flex items-center gap-2 mb-6">
            <Building2 className="w-6 h-6 text-primary" />
            <span className="font-display font-bold">İş Yönetim</span>
          </div>
          <h2 className="font-display text-2xl font-bold mb-1">Giriş Yap</h2>
          <p className="text-sm text-muted-foreground mb-6">Hesabınıza erişmek için bilgilerinizi girin.</p>
          <form onSubmit={onSubmit} className="space-y-4" autoComplete="off">
            <div className="space-y-1.5">
              <Label htmlFor="email">E-posta</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                autoComplete="off" data-testid="login-email" placeholder="ornek@firma.com" />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="password">Şifre</Label>
              <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                autoComplete="new-password" data-testid="login-password" placeholder="••••••••" />
            </div>
            <Button type="submit" className="w-full" disabled={loading} data-testid="login-submit">
              {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
            </Button>
          </form>
        </Card>
      </div>
    </div>
  );
}

function Stat({ k, v }) {
  return (
    <div>
      <div className="font-display font-bold text-2xl">{v}</div>
      <div className="text-xs text-slate-400 uppercase tracking-widest">{k}</div>
    </div>
  );
}
